import React, { useCallback } from 'react'
import { observer } from 'mobx-react'
import rootStore from '../../../../store/RootStore'
import {
  Box,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper as CHStepper,
  StepSeparator,
  StepStatus,
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'

const steps = [
  { title: 'First', description: 'Data Source and Blueprint' },
  { title: 'Second', description: 'Report Structure' },
  { title: 'Third', description: 'Section Filters' },
  { title: 'Fourth', description: 'Summary' },
  { title: 'Fifth', description: 'Name & Notes' },
]

const Stepper = observer(() => {
  const {
    wizardStore: { currentStep },
  } = rootStore
  const navigate = useNavigate()

  const handleStepClick = useCallback(
    index => {
      const step = index + 1
      if (step > currentStep) return
      rootStore.wizardStore.setCurrentStep(step)
      navigate(`/create-report/${step}`)
    },
    [currentStep, navigate],
  )
  return (
    <CHStepper
      index={currentStep}
      mb="24px"
      p="0 16px">
      {steps.map((step, index) => (
        <Step
          key={index}
          onClick={() => handleStepClick(index)}
          cursor="pointer">
          <StepIndicator
            w="20px"
            h="20px">
            <StepStatus
              complete={
                <StepIcon
                  boxSize="12px"
                  border="none"
                />
              }
              incomplete={<StepNumber fontSize="12px" />}
              active={<StepNumber fontSize="12px" />}
            />
          </StepIndicator>

          <Box>
            <StepDescription>{step.description}</StepDescription>
          </Box>

          <StepSeparator />
        </Step>
      ))}
    </CHStepper>
  )
})

Stepper.propTypes = {}

export default Stepper
